import * as yup from 'yup';

export const RetornoContribuicaoSchema = yup.object({
  declaracao: yup.bool().oneOf([true], 'Atenção, Clique em Declaração'),
});

export const RetornoContribuicaoInitialValues = {
  declaracao: false,
};
